<ng-container *transloco="let t;">
<ng-container *ngIf="!item.hidden">
  <!-- item with router url -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && !item.externalUrl"
    [routerLink]="[item.url]"
    [target]="item.openInNewTab ? '_blank' : '_self'"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- item with external url -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && item.externalUrl"
    [href]="item.url"
    [target]="item.openInNewTab ? '_blank' : '_self'"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <ng-template #itemContent>
    <ng-container *ngIf="item?.hasSvgIcon; else featherIcon">
        <div class="main-menu-eform-icon" [innerHTML]="item?.icon | safe : 'html' "></div>
    </ng-container>

    <ng-template #featherIcon>
      <span [data-feather]="item?.icon" *ngIf="item?.icon"></span>
    </ng-template>
    <span class="menu-title text-truncate" [translate]="item.translate">{{ t(item.translate) }}</span>
    <span
      class="badge ms-auto me-1"
      *ngIf="item.badge"
      [translate]="item.badge.translate"
      [ngClass]="item.badge.classes"
    >
      {{ item.badge.title }}
    </span>
  </ng-template>
</ng-container>
</ng-container>